const profiles = {
  en: {
    initials: 'YC',
    location: 'Melbourne',
    country: 'Australia',
    email: 'cyi18@icloud.com',
    contentLanguage: 'en',
    displayName: 'Yi Chen',
    homeHeadline: 'I build software and write about how it works.',
    homeIntro: 'CodeCognition is my personal space for documenting projects, technical decisions and lessons learned while building software.',
    aboutTitle: 'A humanities perspective, applied to software engineering.',
    aboutIntro: 'I’m Yi Chen, an IT master’s student and software engineer focused on backend systems and AI applications. I care about software that is useful, explainable and built with intention.',
    paragraph1: 'My path into technology began outside computer science. That background shaped how I work today: understand the context, communicate the trade-offs and keep the person using the system in view.',
    paragraph2: 'CodeCognition is my personal engineering notebook—a place where I share completed projects, architecture decisions and what I learned along the way.',
    paragraph3: 'The work here ranges from conventional Spring Boot services to retrieval pipelines and modern React interfaces.',
    authorBio: 'Hi, I’m a humanities graduate now studying IT. This site is my personal engineering notebook for projects, development notes and lessons learned.',
  },
  zh: {
    initials: 'YC',
    location: 'Melbourne',
    country: 'Australia',
    email: 'cyi18@icloud.com',
    contentLanguage: 'zh',
    displayName: '陈宜',
    homeHeadline: '我构建软件，也记录它是如何工作的。',
    homeIntro: 'CodeCognition 是我的个人技术空间，用来记录完成的项目、技术决策，以及构建软件过程中的经验。',
    aboutTitle: '把人文学科的视角带入软件工程。',
    aboutIntro: '我是陈宜，一名 IT 硕士研究生和软件开发者，主要关注后端系统与 AI 应用。我重视软件的实用性、可解释性和清晰的设计意图。',
    paragraph1: '我并非从计算机专业起步。这段经历塑造了我的工作方式：先理解问题背景，讲清楚技术取舍，并始终关注真正使用系统的人。',
    paragraph2: 'CodeCognition 是我的个人工程笔记，用来分享完成的项目、架构决策，以及实践过程中获得的经验。',
    paragraph3: '这里的内容涵盖传统 Spring Boot 服务、检索系统，以及现代 React 界面。',
    authorBio: '你好，我原本学习人文学科，目前正在攻读 IT 硕士。这里是我的个人工程笔记，用来记录项目、开发经验和实践中的思考。',
  },
};

export const getProfileFallback = (language = 'en') => (
  language.startsWith('zh') ? profiles.zh : profiles.en
);
